module.exports = __webpack_public_path__ + "img/ic_back_header-dark.e1ab122.svg";